import { useState, useEffect, useCallback, useMemo } from "react";
import { useSkillCategory } from "../../hooks/useSkillCategory";
export const SkillCategoryModel = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [successModal, setSuccessModal] = useState(null);

    const {
        GetSkillCategories,
        createSkillCategory,
        UpdateSkillCategory,
        DeleteSkillCategory,
        cacheOperations: { readSkillCategory, writeSkillCategory }
    } = useSkillCategory();

    const fetchData = useCallback(async () => {
        if (loading) return;
        setLoading(true);
        setError(null);

        try {
            const skillResult =
                await GetSkillCategories();
            if (
                !skillResult.success
            ) {
                throw new Error("Failed to fetch required data");
            }
            writeSkillCategory(skillResult.data);
        } catch (err) {
            setError(err.message);
            console.error("Error fetching data:", err);
        } finally {
            setLoading(false);
        }
    }, [
        GetSkillCategories,
        writeSkillCategory
    ]);

    useEffect(() => {
        fetchData();
    }, []);

    const handleCreateSkillCategory = useCallback(
        async (formData) => {
            try {
                const result = await createSkillCategory(formData);
                if (result.success) {
                    setSuccessModal("Skill category created successfully");
                    return { success: true };
                } else {
                    throw new Error(result.error);
                }
            } catch (error) {
                console.error("Error creating skill category:", error);
                throw new Error(error.message);
            }
        },
        [createSkillCategory]
    );

    const handleUpdateSkillCategory = useCallback(
        async (categoryId, formData) => {
            try {
                const result = await UpdateSkillCategory(categoryId, formData);
                if (result.success) {
                    setSuccessModal("Skill Category updated successfully");
                    return { success: true };
                } else {
                    throw new Error(result.error);
                }
            } catch (error) {
                console.error("Error updating skill category:", error);
                throw new Error(error.message);
            }
        },
        [UpdateSkillCategory]
    );

    const handleDelete = useCallback(
        async (category) => {
            try {
                const result = await DeleteSkillCategory(category.skill_category_id);
                if (result.success) {
                    setSuccessModal("Skill category deleted successfully");
                } else {
                    setError(result.error);
                }
            } catch (err) {
                setError(err.message);
                console.error("Error deleting skill category:", err);
            }
        },
        [DeleteSkillCategory]
    );

    return {
        categories: readSkillCategory(),
        loading,
        error,
        createSkillCategory: handleCreateSkillCategory,
        UpdateSkillCategory: handleUpdateSkillCategory,
        handleDelete,
        successModal,
        setSuccessModal,
        refetch: fetchData,
    };
};
